<template>
  <div dir="rtl" class="card shadow rounded text-right">
    <a :href="result.cook_page.url" class="w-auto pointer position-relative" style="margin-bottom: 30px" @click="trackClick">
    <!-- <span class="w-auto pointer position-relative" style="margin-bottom: 30px" @click="showCook()"> -->
      <SectionImageComponent :image="$responsive(result.pictures.atmosphere_picture)" />
      <LikeComponent v-if="result.likes" :likes="result.likes" position="top-right" @click.stop="false" />
      <CookAndMeInCookCardComponent v-else-if="result.cook_and_me" :cook_and_me="result.cook_and_me" @click.stop="false" />
      <RatingComponent :rating="result.rating_preview" style="top: 15px; left: 20px; background-color:rgba(255,255,255,0.8); border-radius: 10px; padding-left:5px; padding-right:5px;" @click.stop.prevent="ratingClicked()" class="pointer position-absolute" />
      <CookHeadComponent v-if="result.pictures.cartoon_picture" :image="$responsive(result.pictures.cartoon_picture)" />
      <YummiExtraComponent v-if="result.yummi_extra" :image="$responsive(result.yummi_extra.image)" :popup_data="result.yummi_extra.popup_data" />
      <CookChoiceBadgeComponent :badgeImage="$responsive(result.pictures.badge)" v-if="result.pictures.badge" />
    </a>
    <!-- </span> -->
    <a :href="result.cook_page.url" class="black-link pointer" style="margin: 0 20px;" @click="trackClick">
    <!-- <div class="pointer" style="margin: 0 20px;" @click="showCook()"> -->
      <div class="f17-l19-m text-truncate-on-carousel" v-html="result.sections.title.title">
      </div>
      <div class="f14-l17 red text-break two-lines-on-carousel two-lines-on-desktop two-lines-on-tablet" v-html="result.sections.subtitle.subtitle"></div>
    <!-- </div> -->
    </a>
    <div class="margin-lr-20 no-margin-on-carousel">
      <div class="f14-l19-l c38 two-lines-on-carousel text-truncate-on-carousel mh-l19 two-lines-on-desktop two-lines-on-tablet" v-for="(description,idx) in result.sections.description" v-html="description.text" :key="idx"></div>
    </div>
    <!-- <div style="margin: 0px 15px; overflow: hidden; min-height: 24px;">
      <DishPreferenceComponent v-for="p in result.sections.cook_filter_tags" :preference="p" :key="p.search_url" />
    </div> -->
    <HorizontalSplitter class="marginTop" />
    <div class="d-flex flex-row f14-l19 margin-20" dir="rtl">
      <div class="flex-fill d-flex flex-column">
        <CookAvailabilityComponent :availability="result.sections.availability" class="d-flex flex-row" :alignRight="true"/>
        <div v-if="result?.sections?.availability?.minimum_order_price_line">{{result.sections.availability.minimum_order_price_line}}&nbsp;</div>
      </div>
      <a class="d-flex text-start align-items-center red-link pointer" :href="result.cook_page.url" @click="trackClick">
        <!-- <a :href="result.cook_page.url" class="red-link pointer"> -->
        <span>{{result.cook_page.text}}</span>
      </a>
      <!-- </div> -->
    </div>
  </div>
</template>
<script>
import LikeComponent from "@/components/generic/LikeComponent.vue";
import CookHeadComponent from "@/components/CookHeadComponent.vue";
import SectionImageComponent from "@/components/generic/SectionImageComponent.vue";
import RatingComponent from "@/components/generic/RatingComponent.vue";
import HorizontalSplitter from "@/components/generic/HorizontalSplitter.vue"
// import DishPreferenceComponent from "@/components/DishPreferenceComponent.vue";
import CookAvailabilityComponent from "@/components/cook/CookAvailabilityComponent.vue";
import CookChoiceBadgeComponent from "@/components/BadgeComponent.vue";
import CookAndMeInCookCardComponent from "@/components/generic/CookAndMeInCookCardComponent.vue";
import {addGoogleAnalyticsDataLayer} from '@/modules/configuration.js';
import YummiExtraComponent from "@/components/YummiExtraComponent.vue";
export default {
  components: {
    LikeComponent,
    CookHeadComponent,
    SectionImageComponent,
    RatingComponent,
    HorizontalSplitter,
    // DishPreferenceComponent,
    CookAvailabilityComponent,
    CookChoiceBadgeComponent,
    CookAndMeInCookCardComponent,
    YummiExtraComponent
},
  props: {
    result: Object
  },
  methods: {
    ratingClicked() {
      this.$router.push(this.result.cook_page.url + "#rating");
    },
    showCook() {
      this.$router.push(this.result.cook_page.url);
    },
    trackClick(event) {
      event.preventDefault();
      const link = event.currentTarget.href; // Get the link URL
      // console.log("TRACKING COOK:", this.result.data_layer)
      // Trigger Google Tag Manager event
      addGoogleAnalyticsDataLayer(this.result.data_layer);
      // console.log("link: ", link)
      setTimeout(() => {
        window.location.href = link;
      }, 200);
    }
  }
}
</script>
<style scoped>
.chef-name {
  font-size: 17px;
  font-weight: bold;
  line-height: 17px;
}

.chef-sub-name {
  font-size: 14px;
  color: #ef3d49;
  line-height: 14px;
}
</style>